<template>
  <b-container class="page-container" style="background-color: #f0f0f0" fluid>
    <RealRecipesCheckout :combos="combos" :key="$route.fullPath"/>
  </b-container>
</template>
<style>

</style>

<script>
import RealRecipesCheckout from "@/components/checkout/realrecipes/RealRecipesCheckout.vue";

export default {
  title: 'Real Recipes Checkout',
  name: "RealRecipes",
  props: ["combos"],
  components: {
    RealRecipesCheckout
  },
};
</script>
